class Sff {

  static name(type) {
    let text = ''

    switch (type) {
      case 1:
        text = '费用';
        break;

      case 2:
        text = '费率';
        break;

      default:
        text = '收费';
    }

    return text
  }

  static getTableHeadText(type, unit) {
    let text = ''

    switch (type) {
      case 1:
        text = `本月使用小程序的时长（${unit}）`;
        break;

      case 2:
        text = `本月使用小程序产生的礼物收益（${unit}）`;
        break;

      default:
        text = `本月累计：${unit}`;
    }

    return text
  }

  static fee(type, fee) {
    let text = ''

    switch (type) {
      case 1:
        text = `${fee / 100} 虎牙币`;
        break;

      case 2:
        text = `${fee}%`;
        break;

      default:
        text = `${fee}`;
    }

    return text
  }

  static condition(type, min, max) {
    let text = ''

    switch (type) {
      case 1:
        if (max == -1) {
          text = `使用时长 >= ${min}`;
        } else {
          text = `${min} <= 使用时长 < ${max + 1}`;
        }
        break;
      case 2:
        if (max == -1) {
          text = `收益 >= ${min}`;
        } else {
          text = `${min} <= 收益 < ${max + 1}`;
        }

        break;
      default:
        text = `[${min}, ${max != -1 ? (max + 1) : '+∞'})`;
    }

    return text
  }

  static getFreeConditionText(type, min) {
    let text = ''

    switch (type) {
      case 1:
        text = `使用时长 < ${min}`;
        break;

      case 2:
        text = `收益 < ${min}`;
        break;

      default:
        text = `${min}`;
    }

    return text
  }
}

export default Sff;